import React, { forwardRef, ReactElement, useEffect, useRef } from 'react';
import { ModalSize } from "../enums/ModalSize";
import { PdsModal } from "@principal/design-system-react";

export type ModalProps = {
    id: string,
    headerText?: string,
    closeable: boolean,
    modalContent?: ReactElement,
    modalFooter?: ReactElement,
    modalSize?: ModalSize,
    onClose?: (e: Event) => void,
    openOnLoad?: boolean
    children?: React.ReactNode
}

const Modal = forwardRef((props: ModalProps, ref) => {
    const localRef = useRef(null);
    const modalRef = (ref ?? localRef) as React.RefObject<any>;
    const openOnLoad = props.openOnLoad !== undefined ? props.openOnLoad : true;

    useEffect(() => {
        const modalRefCurrent = modalRef.current
        return () => {
            modalRefCurrent?.trap?.deactivate();
        };
    }, [modalRef])

    return (
        <PdsModal id={props.id}
                  modalTitle={props.headerText ?? ""}
                  hideCloseButton={!props.closeable}
                  size={props.modalSize}
                  ref={modalRef}
                  openOnLoad={openOnLoad}
                  pdsModalClose={props.onClose}>
            <div>
                {props.modalContent}
            </div>
            <div slot="footer">
                {props.modalFooter}
            </div>
        </PdsModal>
    )
});
export default Modal;